import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import { type AuthenticationState, type LoginActionType, type LoginResponseType } from '@app-types/AuthenticationTypes'

const initialState: AuthenticationState = {
    loginLoading: false,
    loginData: null,
    loginError: null,
    isAuthenticated: false,
}

const authenticationSlice = createSlice({
    name: 'authentication',
    initialState,
    reducers: {
        handleLogin(state, action: PayloadAction<LoginActionType>) {
            state.loginLoading = true
            state.loginError = null
        },
        handleLoginSuccess(state, action: PayloadAction<LoginResponseType>) {
            const { url } = action.payload
            window.location.href = url
            state.loginData = action.payload
            state.loginLoading = false
            state.loginError = null
        },
        handleLoginFailure(state, action: PayloadAction<any>) {
            state.loginError = action.payload
            state.loginLoading = false
        },
        setIsAuthenticated(state, action: PayloadAction<boolean>) {
            state.isAuthenticated = action.payload
        },
    },
})

export const { handleLogin, handleLoginSuccess, handleLoginFailure, setIsAuthenticated } = authenticationSlice.actions
export default authenticationSlice.reducer
